import React from 'react';
import { PlusIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from 'components/ui/button';
import { TotemTrashButton } from '../TotemTrashButton';
import { TotemLabel } from '../TotemLabel';

type DetailListProps = {
    label?: string;
    sublabel?: string;
    items: React.ReactNode[];
    onAdd?: () => void;
    addLabel?: string;
    className?: string;
    maxHeight?: string;
};

export const DetailList = ({ label, sublabel, items, onAdd, addLabel, className, maxHeight }: DetailListProps) => {
    return (
        <div className={cn('inline-flex flex-col gap-[5px]', className)}>
            {label || sublabel ? (
                <div className="flex flex-col">
                    {label ? <TotemLabel>{label}</TotemLabel> : null}
                    {sublabel ? <span className="text-muted-foreground text-[13px]">{sublabel}</span> : null}
                </div>
            ) : null}
            <div
                className="flex min-w-[200px] flex-col overflow-hidden rounded-lg border border-border"
                style={maxHeight ? { maxHeight, overflowY: 'auto' } : undefined}
            >
                {items.map((item, index) => (
                    <div
                        key={index}
                        className={cn('flex items-center gap-1.5 p-1.5', index > 0 && 'border-t border-border')}
                    >
                        {item}
                    </div>
                ))}
                {onAdd ? (
                    <div
                        className={cn('flex items-center gap-1.5 p-1.5', items.length > 0 && 'border-t border-border')}
                    >
                        <Button type="button" size="icon-sm" onClick={onAdd}>
                            <PlusIcon />
                        </Button>
                        {addLabel ? <span className="text-sm text-muted-foreground">{addLabel}</span> : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export const DetailListRemoveButton = ({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) => {
    return <TotemTrashButton onClick={onClick} disabled={disabled} />;
};
